module.exports = __webpack_public_path__ + "img/savlon-liquid.d4df38e9.jpg";